import React from 'react';
import { useTrueMobile } from 'shared/hooks/useTrueMobile';
import { useAppStore } from 'store/app/appStore';

interface DynamicSwipeBlockProps {
  borderColor?: string;
  fillColor?: string;
  strokeWidth?: number;
  className?: string;
  onClick?: () => void;
}

const DynamicSwipeBlock: React.FC<DynamicSwipeBlockProps> = ({
  strokeWidth = 1,
  className,
  onClick
}) => {
  const resolvedFill = 'var(--campaign-gradient-fill, var(--campaign-color-primary, #3F0F6B))';
  const resolvedBorder = 'var(--campaign-color-border, var(--campaign-color-primary, #7200B9))';

  const openType = useAppStore((state) => state.settings.openType);
  const isMobile = useTrueMobile();
  const ingameMobile = openType === 'ingame' && isMobile;

  return (
    <svg
      width="70"
      height="21"
      viewBox="0 0 70 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      style={{
        ...(onClick ? { cursor: 'pointer' } : {}),
        ...(ingameMobile ? { transform: 'translate(-50%, 63%)' } : {}),
      }}
    >
      <g clipPath="url(#clip0_8858_98039)">
        <path
          d="M247 -8C247 -2.47716 242.523 2 237 2H68.5231C64.4025 2 60.8325 4.63176 58.4877 8.02019C53.1923 15.6725 44.3531 20.6855 34.3428 20.6855C24.3324 20.6855 15.4932 15.6725 10.1978 8.02017C7.85303 4.63174 4.28311 2 0.162506 2H-167C-172.523 2 -177 -2.47716 -177 -8V-214C-177 -219.523 -172.523 -224 -167 -224H237C242.523 -224 247 -219.523 247 -214V-8Z"
          fill={resolvedFill}
          stroke={resolvedBorder}
          strokeWidth={strokeWidth}
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <defs>
        <clipPath id="clip0_8858_98039">
          <rect width="70" height="21" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DynamicSwipeBlock;
